import { ListingById } from '../../types/General';
import { TRANSMISSION_TYPE, VEHICLE_CONDITION, VEHICLE_TYPE } from '../../utils/enums';

type props = {
  type: any;
  details: ListingById | undefined;
};

const BasicInformation = ({ type, details }: props) => {
  return (
    <>
      <div className="profileInfo_head">
        <h2>Basic Information</h2>
      </div>

      <div className="profileInfo_list">
        <ul className="text_info gap_p">
          {/* <li className="w_50">
            <strong>Vehicle Id</strong>
            <span>#CR1987876</span>
          </li> */}
          <li className="w_50">
            <strong>Vehicle Type</strong>
            <span>
              {type == VEHICLE_TYPE.CAR
                ? 'Car'
                : type == VEHICLE_TYPE.BIKE
                  ? 'Bike'
                  : type == VEHICLE_TYPE.TRUCK
                    ? 'Truck'
                    : type == VEHICLE_TYPE.HEAVY_VEHICLE
                      ? 'Heavy Vehicle'
                      : '- -'}
            </span>
          </li>
          <li className="w_50">
            <strong>Title</strong>
            <span>{details?.title || '-'}</span>
          </li>
          <li className="w_50">
            <strong>New Vehicle</strong>
            <span>{details?.condition === VEHICLE_CONDITION.NEW ? 'Yes' : 'No'}</span>
          </li>
          <li className="w_50">
            <strong>Brand</strong>
            <span>{details?.brand?.name || '-'}</span>
          </li>
          <li className="w_50">
            <strong>Model</strong>
            <span>{details?.model?.name || '-'}</span>
          </li>

          <li className="w_50">
            <strong>Body Type</strong>
            <span>{details?.bodyType?.name || '-'}</span>
          </li>
          <li className="w_50">
            <strong>Mileage</strong>
            <span>{details?.mileage || 0} kmpl</span>
          </li>
          {/* <li className="w_50">
            <strong>Year</strong>
            <span>-</span>
          </li> */}
          <li className="w_50">
            <strong>Fuel Type</strong>
            <span>{details?.fuelType?.name || '-'}</span>
          </li>
          <li className="w_50">
            <strong>GCC</strong>
            <span>{details?.gcc?.name || '-'}</span>
          </li>
          <li className="w_50">
            <strong>Approval Status</strong>
            <span>
              {details?.status === 1 ? 'Pending' : details?.status === 2 ? 'Approved' : 'Rejected'}
            </span>
          </li>
          <li className="w_50">
            <strong>Exterior Color</strong>
            <span>{details?.color?.exteriorColor?.name || '-'}</span>
          </li>
          <li className="w_50">
            <strong>Interior Color</strong>
            <span>{details?.color?.interiorDetails?.name || '-'}</span>
          </li>
          <li className="w_50">
            <strong>Seats</strong>
            <span>{details?.seat || 0}</span>
          </li>
          {type == VEHICLE_TYPE.CAR ? null : (
            <li className="w_50">
              <strong>Drive Type</strong>
              <span>{details?.driveSystem || '-'}</span>
            </li>
          )}
          <li className="w_50">
            <strong>Transmission</strong>
            <span>{details?.transmission ? TRANSMISSION_TYPE[details?.transmission] : '-'}</span>
          </li>
          <li className="w_50">
            <strong>Power</strong>
            <span>{details?.horsePower?.name || '-'}</span>
          </li>
          <li className="w_50">
            <strong>Engine Capacity</strong>
            <span>
              {details?.engineCapacity?.min || 0}-{details?.engineCapacity?.max || 0} cc
            </span>
          </li>
          <li className="w_50">
            <strong>Price</strong>
            <span>AED {details?.price || 0}</span>
          </li>
          <li className="w_50">
            <strong>Address</strong>
            <span>{details?.addressObject?.address || '-'}</span>
          </li>
          <li className="w_50">
            <strong>City</strong>
            <span>{details?.addressObject?.city || '-'}</span>
          </li>
          <li className="w_50">
            <strong>State</strong>
            <span>{details?.addressObject?.state || '-'}</span>
          </li>
        </ul>
        <ul className="text_info gap_p" style={{ marginTop: '10px' }}>
          {type == VEHICLE_TYPE.BIKE ? null : (
            <>
              <li style={{ flexDirection: 'column' }}>
                <strong>Fleet Damage</strong>
                <span>
                  {details?.damages?.length
                    ? details?.damages?.map((damage) => damage.name).join(', ')
                    : '-'}
                </span>
              </li>
              <li style={{ flexDirection: 'column' }}>
                <strong>Accident History</strong>
                <span>{details?.accidentHistoryDesc || '-'}</span>
              </li>
            </>
          )}
          <li style={{ flexDirection: 'column' }}>
            <strong>Description</strong>
            <span> {details?.description || '-'}</span>
          </li>
        </ul>
        <div className="gap_p">
          <div className="w_50">
            <h3>Features</h3>
            <ul className="text_info gap_p">
              {details?.features?.length ? (
                details?.features?.map((item, i: number) => {
                  return (
                    <li key={i}>
                      <strong>{item?.name}</strong>
                    </li>
                  );
                })
              ) : (
                <li>-</li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default BasicInformation;
